// DESIGN_SYSTEM_NOTES: token --wfm-* soltanto, nessun componente nuovo oltre
// a questa striscia. Si comporta come un'intestazione della pagina, non come
// una barra di navigazione: sta dentro l'area di contenuto.
//
// Le schede delle pagine raggruppate.
//
// Il menu è passato da 46 voci a 22 raccogliendo più pagine sotto una voce
// sola. Le pagine però non si sono toccate: ognuna ha ancora il suo indirizzo,
// il suo componente e il suo permesso. Questa striscia è l'unica cosa che le
// tiene insieme, e si disegna da sola a partire da `navConfig` — quindi non
// può divergere dal menu, perché legge la stessa struttura.
//
// Due regole:
//   - si mostrano **solo** le schede che quella persona può aprire (ruolo,
//     moduli, permessi): chi ha diritto a una sola pagina del gruppo non deve
//     nemmeno vedere i nomi delle altre;
//   - con una scheda sola non compare niente: una striscia con un elemento
//     è rumore.

import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAuthStore } from '../../stores/auth.store';
import { usePermessiStore } from '../../stores/permessi.store';
import { schedeDiPercorso } from '../../lib/navConfig';

export default function SchedePagina({ children }) {
  const user = useAuthStore((s) => s.user);
  const permessi = usePermessiStore((s) => s.permessi);
  const catalogo = usePermessiStore((s) => s.catalogo);
  const stato = usePermessiStore((s) => s.stato);
  const { pathname } = useLocation();

  const schede = schedeDiPercorso(
    pathname,
    user,
    stato === 'pronto' ? { permessi, catalogo } : null,
  );

  if (schede.length <= 1) return children;

  const inSubPratica = pathname.startsWith('/pratiche/');
  const activeSchedaTo = [...schede]
    .sort((a, b) => b.to.length - a.to.length)
    .find((s) => pathname === s.to || pathname.startsWith(`${s.to}/`))?.to;

  return (
    <>
      <nav
        className="flex items-center justify-between gap-2 overflow-x-auto overflow-y-hidden border-b mb-5"
        style={{ borderColor: 'var(--wfm-border)' }}
        aria-label="Sezioni della pagina"
      >
        <div className="flex items-center gap-1">
          {schede.map((s) => {
            const isActive = activeSchedaTo === s.to;
            return (
              <NavLink
                key={s.to}
                to={s.to}
                end
                className={`px-3.5 py-2 text-[13px] font-semibold whitespace-nowrap rounded-t-lg border-b-2 -mb-px transition-colors ${
                  isActive ? 'wfm-scheda-attiva' : 'wfm-scheda'
                }`}
              >
                {s.label}
              </NavLink>
            );
          })}
        </div>
        {inSubPratica && (
          <Link
            to="/pratiche"
            className="wfm-btn-secondary wfm-btn-sm mb-1.5 shrink-0 no-underline"
          >
            <ArrowLeft size={14} strokeWidth={2} />
            <span>Tutti i moduli</span>
          </Link>
        )}
      </nav>
      {children}
    </>
  );
}
